import * as React from 'react'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import clsx from 'clsx'
import { capitalize } from '@applift/factor'
import style from '../../style'

enum GridColumnHeaderSeparatorSides {
  Left = 'left',
  Right = 'right',
}

export interface GridColumnHeaderSeparatorProps
  extends React.HTMLAttributes<HTMLDivElement> {
  resizable: boolean
  resizing: boolean
  height: number
  side?: GridColumnHeaderSeparatorSides
}

function GridColumnHeaderSeparatorRaw(props: GridColumnHeaderSeparatorProps) {
  const {
    resizable,
    resizing,
    height,
    side = GridColumnHeaderSeparatorSides.Right,
    ...other
  } = props
  const rootProps = useGridRootProps()

  const stopClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      event.preventDefault()
      event.stopPropagation()
    },
    []
  )

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className={clsx(
        [style.columnSeparator, rootProps.classes?.columnSeparator],
        resizable && [
          style['columnSeparator--resizable'],
          rootProps.classes?.['columnSeparator--resizable'],
        ],
        resizing && [
          style['columnSeparator--resizing'],
          rootProps.classes?.['columnSeparator--resizing'],
        ],
        side && [
          // @ts-ignore
          style[`columnSeparator--side${capitalize(side)}`],
          // @ts-ignore
          rootProps.classes?.[`columnSeparator--side${capitalize(side)}`],
        ]
      )}
      style={{
        minHeight: height,
        opacity: rootProps.showColumnRightBorder ? 0 : 1,
      }}
      {...other}
      onClick={stopClick}
    >
      <svg
        className="ic-svg fs-small ic-separator"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 24 24"
      >
        <path d="M11 19V5h2v14z"></path>
      </svg>
    </div>
  )
}

const GridColumnHeaderSeparator = React.memo(GridColumnHeaderSeparatorRaw)

export { GridColumnHeaderSeparator, GridColumnHeaderSeparatorSides }
